import { Mapper } from "../../../../base/utils/mapper";
import { ExtensionModel } from "../../../../domain/models/consult/extension.model";
import { ExtensionEntity } from "../entities/extension.entity";

export class ExtensionImplementationRepositoryMapper extends Mapper<ExtensionEntity, ExtensionModel> {
    mapFrom(param: ExtensionEntity): ExtensionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ExtensionModel): ExtensionEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}